import React from "react";
import PropTypes from "prop-types";
import { Typography, FormControl } from "@mui/material";
import { withTranslation } from "react-i18next";
import EMPSelectField from "../../../shared/components/EMPSelectField/EMPSelectField";

const select = "select";

function getMenuItems(props) {
  const menuItems = [
    {
      text: props.t("AccessoriesSearch.select"),
      value: select,
      disabled: true,
    },
  ];

  props.categoryDropDownValues.forEach((category) => {
    menuItems.push({
      text: category,
      value: category,
    });
  });

  return menuItems;
}

class CategoryDropDown extends React.Component {
  render() {
    const props = this.props;

    return (
      <>
        <Typography variant="body2">
          {props.t("AccessoriesSearch.category")}
        </Typography>
        <div
          data-testid="categoryDropdown"
          className={props.styles.modelDropdownDiv}
        >
          <FormControl className={props.styles.modelFormControl}>
            <EMPSelectField
              testId="categorySelect"
              value={props.selectedCategory}
              onChange={(event) => props.updateCategory(event)}
              menuItems={getMenuItems(props)}
            />
          </FormControl>
        </div>
      </>
    );
  }
}

CategoryDropDown.propTypes = {
  t: PropTypes.func.isRequired,
  styles: PropTypes.shape({
    modelDropdownDiv: PropTypes.string,
    modelFormControl: PropTypes.string,
  }).isRequired,
  selectedCategory: PropTypes.string,
  updateCategory: PropTypes.func.isRequired,
  categoryDropDownValues: PropTypes.arrayOf(PropTypes.string).isRequired,
};

CategoryDropDown.defaultProps = {
  selectedCategory: select,
};

export default withTranslation("emp")(CategoryDropDown);
